<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { get } from "svelte/store";

  import Window from "../components/Window.svelte";
  import SettingsMgr from "../stores/SettingsMgr";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { FileMgr } from "../stores/FileMgr";
  import Path from "../scripts/Path";
  import type { Dir } from "../scripts/FileTypes";
  import ProcMgr from "../stores/ProcMgr";
  export let winProps: WinProps;

  const filemgr = FileMgr.getInstance();
  const procmgr = ProcMgr.getInstance();

  //Bindings ==========================================================
  let contElem: HTMLElement,
    pathViewElem: HTMLElement,
    navNext: HTMLElement,
    navPrev: HTMLElement;
  let imgElem: HTMLImageElement;
  let innerWidth, innerHeight;

  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    contElem.style.setProperty("color", c["1"]);
    contElem.style.setProperty("background-color", c["2"]);

    pathViewElem.style.setProperty("color", c["2"]);
    pathViewElem.style.setProperty("background-color", c["1"]);
    navNext.style.setProperty("color", c["2"]);
    navNext.style.setProperty("background-color", c["1"]);
    navPrev.style.setProperty("color", c["2"]);
    navPrev.style.setProperty("background-color", c["1"]);

    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);
  //Props======================================================
  const setWinProps = () => {
    if (!winProps.data) {
      winProps.data = {};
    }
    winProps.name = winProps.name || "Image viewer";
  };
  setWinProps();
  //Window callbacks================================================
  let setWindowRect, setWindowPrevRect;
  const setRectSaver = (func) => {
    setWindowRect = func;
    return true;
  };
  const onWindowRectFinish = (params) => {
    return true;
  };
  const callbacks: WinCbs = {
    // onFocus: handleFocus,
    // closeWindow: setCloseWindow,
    // maximizeWindow: setMaximizeWindow,
    setWindowRect: (func) => {
      setWindowRect = func;
      return true;
    },
    setWindowPrevRect: (func) => {
      setWindowPrevRect = func;
      return true;
    },
    onWindowRectFinish: onWindowRectFinish,
  };
  // winProps["maximizeOnMount"] = true;

  const setPath = (path) => {
    nodePath = path || "";
    if (nodePath.length) {
      src =
        FileMgr.getInstance().findFile(new Path(nodePath))?.data["src"] || "";
      navNext.style.setProperty("display", "normal");
      navPrev.style.setProperty("display", "normal");
    } else {
      src = "";
      navNext.style.setProperty("display", "none");
      navPrev.style.setProperty("display", "none");
    }

    _colors = themeWatcher($_theme);
    setPageNo();
  };
  let _dir;
  let pageNumber = "";
  let imgLen;
  const setPageNo = () => {
    if (!imgLen) {
      return;
    }
    pageNumber = `[${thisIndex() + 1}/${imgLen}]`;
  };
  const watchDir = (dir: Dir) => {
    if (!dir) {
      //clean up
      {
        const _hide = (_elem) => {
          if (_elem) {
            _elem.style.setProperty("display", "none");
          }
        };
        _hide(navNext);
        _hide(navPrev);
        _hide(pathViewElem);
        _hide(imgElem);
        nodePath = "";
        src = "";
        if (setWindowRect) {
          setWindowRect({
            top: "30%",
            left: "30%",
            width: "40%",
            height: "40%",
          });
        }
      }
      return { imgs: undefined };
    }
    const imgs = dir.files
      .filter((file) => file.node.type === "image")
      .map((file) => file.node.path.path)
      .sort();

    thisIndex = () => imgs.indexOf(nodePath);
    imgLen = imgs.length;
    if (imgs.length) {
      setPageNo();
    }
    return {
      imgs: imgs,
    };
  };
  let thisIndex;
  $: dirWatcher = watchDir($_dir);
  const toNext = () => {
    console.log("This index :", thisIndex());
    if (thisIndex() < 0 || !dirWatcher.imgs) {
      setPath("");
      return;
    }
    const nextIdx =
      thisIndex() >= dirWatcher.imgs.length - 1 ? 0 : thisIndex() + 1;
    setPath(dirWatcher.imgs.at(nextIdx));
  };
  const toPrev = () => {
    console.log("This index :", thisIndex());
    const prevIdx =
      thisIndex() <= 0 ? dirWatcher.imgs.length - 1 : thisIndex() - 1;
    if (filemgr.findFile(new Path(dirWatcher.imgs.at(prevIdx)))) {
      setPath(dirWatcher.imgs.at(prevIdx));
    } else {
      setPath("");
    }
  };

  const calcRect = () => {
    const _w = imgElem.naturalWidth;
    const _h = imgElem.naturalHeight;
    const ver = _h > _w;
    console.log("Image nw / nh : ", _w, "/", _h);
    let h = 80;
    const viewH = innerHeight * (h / 100.0) - 30;
    const viewW = viewH * (_w / _h);
    let w = (viewW * 100.0) / innerWidth;
    if (w > 80) {
      //horizontal
      console.log("Is hor");
      const w = 80;
      const viewW = innerWidth * (w / 100.0);
      const viewH = viewW * (_h / _w);
      h = (viewH * 100.0) / innerHeight;
      console.log("H : ", h);
    }
    let top, left, width, height;
    top = `${Math.floor((100 - h) / 2.0)}%`;
    left = `${Math.floor((100 - w) / 2.0)}%`;
    width = `${w}%`;
    height = `${h}%`;

    const rect = {
      top: top,
      left: left,
      width: width,
      height: height,
    };
    return rect;
  };

  onMount(() => {
    // clearInterval(toggleBackground);

    if (imgElem) {
      imgElem.onload = function () {
        const rect = calcRect();
        console.log("Rect : ", rect);
        if (!isMaximized()) {
          setWindowRect(rect);
        } else {
          setWindowPrevRect(rect);
        }
      };
    }
    if (winProps.data?.path) {
      const p = winProps.data.path;
      if (p.length) {
        setPath(p || "");
        _dir = filemgr.findDirReadable(new Path(new Path(p).parent));
        dirWatcher = watchDir($_dir);
      }
    } else {
      navPrev.style.setProperty("display", "none");
      navNext.style.setProperty("display", "none");
    }
    _colors = themeWatcher($_theme);
  });
  let _fetcher;
  let isMaximized = () => {
    _fetcher = procmgr.winDataFetcher(winProps.id);
    if (!_fetcher) {
      return false;
    }
    return get(_fetcher["isMaximized"]());
  };

  onDestroy(() => {});
  let nodePath = "";
  let src = "",
    alt = "";
  let path = "";
</script>

<svelte:window bind:innerHeight bind:innerWidth />

<Window {winProps} {callbacks}>
  <div class="container" bind:this={contElem}>
    <div class="img-wrapper">
      <img {src} {alt} class="image" bind:this={imgElem} />
      {#if src.length === 0}
        <div class="no-image">No image found!</div>
      {/if}
    </div>
    <div class="nav next" bind:this={navNext} on:click={toNext}>&gtcc;</div>
    <div class="nav prev" bind:this={navPrev} on:click={toPrev}>&ltcc;</div>
    <span class="path-view" bind:this={pathViewElem}
      >{nodePath}&nbsp;{pageNumber}</span
    >
  </div>
  <div class="css-keeper" />
</Window>

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .container:hover .path-view {
    opacity: 1;
  }

  .path-view {
    position: absolute;
    right: 0;
    bottom: 0;
    border-top-left-radius: 10px;
    padding: 3px;
    font-size: 1rem;
    opacity: 0.2;
    box-sizing: border-box;
    transition: 0.3s;
  }

  .img-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;

    position: absolute;
    top: 0;
    left: 0;
  }
  .image {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    object-fit: contain;
    object-position: center center;
  }

  .no-image {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    font-size: 2rem;
    transform: translate(-50%, -50%);
  }
  .nav {
    position: absolute;
    top: 0;
    min-width: 100px;
    width: 15%;
    height: 100%;
    font-size: 5rem;
    /* background-color: thistle; */
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: 0.3s;
    cursor: pointer;
  }
  .nav:hover {
    opacity: 0.8;
  }
  .next {
    right: 0;
  }
  .prev {
    left: 0;
  }
  .css-keeper {
    display: none;
  }
</style>
